// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"b7d7f10d","72":"261c940c","85":"c32eaf75","163":"22653ba7","196":"fc6fa9f0","351":"ffdd67a4","631":"43ae070b","787":"cf53dd50"}[chunkId] + ".chunk.js";
};